export enum PastProjectType {
    System = "system",
    Launch = "launch",
    Partnership = "partnership",
}

export interface PastProject {
    customer?: string;
    dateCompleted?: Date;
    dateConducted: Date;
    description: string;
    organizationId: string;
    pastprojectid: string;
    productList: string[];
    projectType: PastProjectType;
    serviceTags: string[];
    title: string;
}

export const pastProjectItemKeys = [
    "customer",
    "dateCompleted",
    "dateConducted",
    "description",
    "productList",
    "projectType",
    "serviceTags",
    "title",
] as const;

export type PastProjectItem = Pick<PastProject, typeof pastProjectItemKeys[number]>;
